import React, { FC } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { LinkButton } from 'src/components';
import * as S from 'src/apps/Buddies/BuddiesPromotionCard/styles';
import memriseConnect from './memrise-connect.png';

const msgs = defineMessages({
  title: {
    defaultMessage: 'Introducing Memrise Connect!',
  },
  description: {
    defaultMessage:
      'Join chatrooms where you can discuss topics with fellow learners and get feedback. Available for all skill levels.',
  },
  cta: {
    defaultMessage: 'Try now',
  },
  close: { id: 'close' },
});

export const MemriseConnectPromoCard: FC<{ onClose: () => void }> = ({ onClose }) => {
  const intl = useIntl();

  return (
    <S.Card data-testid="memrise-connect-promotion-card">
      <S.CloseButton
        onClick={onClose}
        title={intl.formatMessage(msgs.close)}
        aria-label={intl.formatMessage(msgs.close)}
      >
        <S.CloseIcon name="close" />
      </S.CloseButton>
      <S.Title>{intl.formatMessage(msgs.title)}</S.Title>
      <S.Description>{intl.formatMessage(msgs.description)}</S.Description>
      <S.BottomWrapper>
        <S.Image src={memriseConnect} alt="" />
        <LinkButton
          buttonType="primary"
          buttonSize="small"
          href="https://memrise.replit.app"
          target="_blank"
        >
          {intl.formatMessage(msgs.cta)}
        </LinkButton>
      </S.BottomWrapper>
    </S.Card>
  );
};
